import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_NAME = 'Write The World Dashboard';

// Maps each route path to a human-readable page name shown in the browser tab.
const PAGE_TITLES = {
  '/': 'Dashboard',
  '/competition': 'Competition',
  '/donor-stats': 'Donor Stats',
  '/created-user-trends': 'Created User Trends',
  '/weekly-unique-user-trends': 'Weekly Unique User Trends',
  '/country-trends': 'Country Trends',
  '/clara-feedback': 'Clara Feedback',
  '/clara-feedback-trends': 'Clara Feedback Trends',
  '/engagement-by-type': 'Engagement By Type',
  '/new-user-referral-trends': 'New User Referral Trends',
  '/total-logins-by-day-and-hour': 'Total Logins by Day and Hour',
  '/percentage-engagement': 'Percentage Engagement',
  '/clara-usage': 'Clara Usage',
  '/educator-domains': 'Educator Domains',
  '/demographics-dashboard': 'Demographics Dashboard',
  '/clara-categorization-iframe-test': 'Clara Category Visualizations',
  '/iframe/competition': 'Competition',
  '/iframe/clara-feedback': 'Clara Feedback',
  '/iframe/clara-feedback-dev': 'Clara Feedback (Dev)',
  '/iframe/clara-feedback-test': 'Clara Feedback (Test)',
  '/iframe/clara-feedback-trends': 'Clara Feedback Trends',
  '/iframe/clara-feedback-trends-dev': 'Clara Feedback Trends (Dev)',
  '/iframe/clara-feedback-trends-test': 'Clara Feedback Trends (Test)',
};

// Keeps the browser tab title in sync with the currently rendered route.
const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const pageName = PAGE_TITLES[location.pathname];
    document.title = pageName ? `${pageName} | ${SITE_NAME}` : SITE_NAME;
  }, [location.pathname]);
};

export default usePageTitle;
